export default __webpack_public_path__ + "static/media/godrej.c76b7c61.svg";